import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CollapseButtonsOnOverflowDirective } from './collapse-buttons-on-overflow.directive';

@NgModule({
  declarations: [CollapseButtonsOnOverflowDirective],
  imports: [CommonModule],
  exports: [CollapseButtonsOnOverflowDirective]
})
export class CollapseButtonsOnOverflowModule {
}
